export default __webpack_public_path__ + "static/media/ticket-6.6a39b8d5.png";